import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import LineSegment from './lineSegment';
import InfiniteScroll from 'react-infinite-scroller';
import { MatchesList } from '~/web-frontend-components/line/matches/List';
import LoadingSpinner from '../loadingSpinner/';

@inject('lineStore', 'igStore')
@observer
export default class Line extends Component {

  componentDidMount() {
    this.props.lineStore.matchesList.subscribe(this.update);
  }
  componentWillUnmount() {
    this.props.lineStore.matchesList.unsubscribe(this.update);
  }

  update = () => {
    this.setState({ upd: Date.now() });
  }

  onVideoClick = (data) => {
    this.props.igStore.setGame(data, 'video');
  };

  onInfographicsClick = (data) => {
    this.props.igStore.setGame(data, 'events');
  };

  isVideoPlaying = (matchID) => {
    return this.props.igStore.video.playing && this.props.igStore.video.gid === matchID;
  };

  isCoefChoosen = (matchID, betID, oddID) => {
    const isCfChoosen = this.props.lineStore.basket.basketData.oddsIds.has(oddID)
    return isCfChoosen
  }

  renderSegment = () => {
    const lineStore = this.props.lineStore;

    if (lineStore.matchesList.getData() && this.props.lineStore.line.mode === 'live') {
      const basket = this.props.lineStore.basket;
      return <MatchesList
        matchesListStore={lineStore.matchesList}
        toLocale={window.getLang}
        mode={this.props.lineStore.line.mode}
        matchHandlers={{
          onInfographicsClick: this.onInfographicsClick,
          isVideoPlaying: this.isVideoPlaying,
          isCoefChoosen: this.isCoefChoosen,
          onCoefChoose: basket.newAddOdd.bind(basket),
          onVideoClick: this.onVideoClick,
        }}
        matchCommonProps={{
          outcomes: lineStore.matchesList.outcomes,
          columnCount: lineStore.line.colCount,
          width: lineStore.matchesList.width,
          displayGamesNumber:true,
          highlightChanges: true,
          isIrm: true,
        }}
      />;
    }

    const { lineSport, mode } = this.props.lineStore.line;
    return lineSport.map((item) => {
      return(
        <LineSegment
          key={item.id}
          id={item.id}
          name={item.name}
          league={item.league}
          mode={mode}
          ref={(LineSegment) => { this['segment_' + item.id] = LineSegment; }}
        />
      )
      }
    )
  };

  loadMore = (pages) => {
    this.props.lineStore.line.loadMore();
  }

  componentDidUpdate() {
    // this.props.lineStore.line.setDivmainScroll();
  }

  setupVisibleSegmentsCaption = () => {
      // console.log(this.lineContainer.current.offsetHeight , 'container');
    // console.log('scroll');
    //   var scrollCtrl = this.refs['lineContainer'];
    //   var scrollHtml = DOM.findDOMNode(scrollCtrl);
    //   var codes = this.segmentCodes();
    //   for (var i = 0; i < codes.length; i++) {
    //       var segmentCtrl = this.refs['segment' + codes[i]];
    //       var segmentHtml = DOM.findDOMNode(segmentCtrl);
    //       var segmentTopVisual = segmentHtml.offsetTop - scrollHtml.scrollTop;
    //       if (segmentTopVisual >= -5) {
    //           if (this.oldTopSegmentId != codes[i]) {
    //               var oldCtrl = this.refs['segment' + this.oldTopSegmentId];
    //               var oldHtml = DOM.findDOMNode(oldCtrl);
    //               if (oldHtml)
    //                   oldHtml.classList.remove('_type_force_captions');
    //               segmentHtml.classList.add('_type_force_captions');
    //               this.oldTopSegmentId = codes[i];
    //           }
    //           break;
    //       }
    //   }
  };

  // onLineScroll = (e) => {
  //     this.setupVisibleSegmentsCaption();
  // };

  render() {
      const {lineSport, isLoading, mode, hasMore} = this.props.lineStore.line;
      // const {basketPosition} = this.props.accountStore.accountSettings;
      const noData = lineSport.length === 0 && this.props.lineStore.matchesList.getData() === null;
      const isWSSLoading = this.props.lineStore.matchesList.isLoading;
      if (isWSSLoading) { return <LoadingSpinner />; }
    return (
      <Fragment>
        { mode === 'live' ? <Header /> : null}
        { noData && !isLoading && !isWSSLoading &&
          <div className="divmain">
            <div className="no-events">Нет событий</div>
          </div>}
        {!noData && mode === 'line' &&
          <InfiniteScroll
            threshold={500}
            pageStart={0}
            loadMore={this.loadMore}
            hasMore={hasMore}
            loader={<div className="load-page-line-link" key={0}>Идет загрузка ...</div>}
            useWindow={false}>
            <div className={mode == 'live' ? 'divmain' : ''} id="divmain" >
              {this.renderSegment()}
            </div>
          </InfiniteScroll>
        }
        {!noData && mode === 'live' &&
          <div className={mode == 'live' ? 'divmain' : ''} id="divmain" > {this.renderSegment()} </div>
        }
      </Fragment>
      )
  }
}

const Header = () => (
  <div className="divmain-head" id="divmain-head">
      <table className="l-t">
          <tbody>
            <tr className="h-tr">
            <th className="g-descr-td" colSpan="4">Событие</th>
            <th className="cf">П1</th>
            <th className="cf">Х</th>
            <th className="cf">П2</th>
            <th className="cf">1Х</th>
            <th className="cf">12</th>
            <th className="cf">Х2</th>
            <th className="cf">Ф1</th>
            <th className="cf">К1</th>
            <th className="cf">Ф2</th>
            <th className="cf">К2</th>
            <th className="cf">Мен</th>
            <th className="cf">Тот</th>
            <th className="cf">Бол</th>
            <th className="cf">Рос</th>
          </tr>
      </tbody>
    </table>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/line/line.js